import React from 'react'

const ControlDiasInventarioContainer = () => (
  <>
    <iframe
      title="Fill Rate"
      width="100%"
      height="90%"
      src="https://app.powerbi.com/reportEmbed?reportId=b466a72b-fdde-4975-92a3-b2f6d9c47f1a&autoAuth=true&ctid=1a8e863a-6a66-4905-990b-f7062b267787"
      frameBorder="0"
      allowFullScreen="true"
    />
  </>
)

export default ControlDiasInventarioContainer
